"use client";

// components/Modal.tsx
import { useAutoTranslate } from "@/lib/i18n/useAutoTranslate";
import { Modal as AntModal } from "antd";
import React from "react";

type ModalProps = {
  height?: number | string;
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode | null;
  width?: number | string;
  centered?: boolean;
  maskClosable?: boolean;
  okText?: string;
  cancelText?: string;
  className?: string;
  closeIcon?: React.ReactNode;
};
const Modal: React.FC<ModalProps> = ({
  open,
  onClose,
  title = "",
  children,
  footer = null,
  width = 430,
  centered = true,
  height = "95vh",
  maskClosable = true,
  okText = "Save",
  cancelText = "Cancel",
  className = "",
  closeIcon,
  ...rest
}) => {
  const tr = useAutoTranslate();

  return (
    <AntModal
      open={open}
      onCancel={onClose}
      title={title}
      footer={footer}
      width={width}
      height={height}
      centered={centered}
      maskClosable={maskClosable}
      okText={tr(okText)}
      cancelText={tr(cancelText)}
      className={className}
      closeIcon={closeIcon}
      style={{ maxHeight: "95vh", overflow: "auto" }}
      {...rest}
    >
      <div className="h-full overflow-auto">{children}</div>
    </AntModal>
  );
};
export default Modal;
